import { z } from "zod"
import { homeForm1BaseSchema } from "./home-form-1.schema"
import { homeForm2Schema } from "./home-form-2.schema"
import { homeForm3Schema } from "./home-form-3.schema"

export const homeFormSchema = z.object({
    ...homeForm1BaseSchema.shape,
    ...homeForm2Schema.shape,
    ...homeForm3Schema.shape,
})

export const updateHomeFormSchema = homeFormSchema.partial()

export type HomeFormSchema = z.infer<typeof homeFormSchema>
export type UpdateHomeFormSchema = z.infer<typeof updateHomeFormSchema>
